// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"3301002a90010db8","9341":"3c3ca2764a97569e"}[chunkId] + ".css";
};